import * as React from 'react';

export function ReactIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={20} height={20} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#react-clip)">
                <path d="M10 11.56a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z" fill="#397096" />
                <path
                    d="M10 13.56c4.418 0 8-1.612 8-3.6s-3.582-3.6-8-3.6-8 1.612-8 3.6 3.582 3.6 8 3.6z"
                    stroke="#397096"
                />
                <path
                    d="M6.883 11.76c2.209 3.826 5.396 6.122 7.118 5.128 1.721-.994 1.326-4.902-.883-8.728C10.91 4.334 7.722 2.038 6 3.032c-1.721.994-1.326 4.902.883 8.728z"
                    stroke="#397096"
                />
                <path
                    d="M6.883 8.16c-2.21 3.826-2.604 7.734-.883 8.728 1.722.994 4.909-1.302 7.118-5.128 2.21-3.826 2.604-7.734.883-8.728-1.722-.994-4.91 1.302-7.118 5.128z"
                    stroke="#397096"
                />
            </g>
            <defs>
                <clipPath id="react-clip">
                    <path fill="#fff" transform="translate(1.6 2.4)" d="M0 0h16.8v15.12H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
